import axios from 'axios';

export const validatePasswordLength = value => (value.length >= 8);

export const confirmPasswordMatch = (value, compareValue) => (value === compareValue);

export const validateEmail = (value) => {
	const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(value);
};

export const validatePhoneNumber = (value) => {
	const phoneFormat1 = /^\+?([0-9]{2})\)?[-. ]?([0-9]{4})[-. ]?([0-9]{4})$/;
	const phoneFormat2 = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
	const phoneFormat3 = /^\d{10}$/;
	if (value.match(phoneFormat1) || value.match(phoneFormat2) || value.match(phoneFormat3)) {
		return true;
	}
	return false;
}

export const validatePAN = (value) => {
	const re = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
	return re.test(value);
};

export const validatePassportNumber = value => {
    const regx = /^[A-PR-WY][1-9]\d\s?\d{4}[1-9]$/gi;
    return regx.test(value);
  };

export const  validatePincode = value => {
	const regx = /^[1-9][0-9]{5}$/;
	return regx.test(value);
	
  };


export const validateLength = (value, length) => (value.length < length);

export const validatePhoneLength = value => (value.length < 14 && value.length > 9);

export const checkIfUserExists = value => new Promise((resolve, reject) => {
	try {
		value = value.replace('+', '%2B').toLowerCase();
		return axios({
			method: 'get',
			url: `/api/v1.1/userDashboard/exists?email=${value}`,
			response: JSON,
		})
			.then((response) => {
				if (response.data) {
					if (response.data.success) {
						resolve(response);
					}
				}
				resolve(null);
			});
	} catch (err) {
		reject(err);
	}
});

export const validatePassword = (password, email, _csrf) => new Promise((resolve, reject) => {
	try {
		return axios({
			method: 'post',
			url: `/api/v1.1/userDashboard/validatep`,
			data: {
				email,
				password,
				_csrf,
			}
		}).then((response) => {
			if (response.data) {
				if (response.data.success) {
					resolve(response);
				}
			}
			resolve(null);
		});
	} catch (e) { reject(e); }
});

export const validatePasswordV2 = (password, email, _csrf) => axios({
			method: 'post',
			url: `/api/v1.1/userDashboard/validatep`,
			data: {
				email,
				password,
				_csrf
			}
		});
